import { Button } from '@evaneos/b2b-ui/legacy';
import { FieldArray, useFormikContext } from 'formik';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { Add } from '../../../../../../design-system/Icons/Add';
import { calculateTotalAmountOfInstalment } from '../../../../../../resources/contract/operations';
import {
    InstalmentViewModel,
    PaymentScheduleViewModel,
} from '../../../../../../resources/contract/types';

import { Instalment } from './Instalment';

import s from './PaymentScheduleStep.module.css';

type Props = {
    defaultDueDate: Date;
    instalments: InstalmentViewModel[];
    name: 'depositInstalments' | 'balanceInstalments';
};

export const InstalmentsList = ({ defaultDueDate, instalments, name }: Props): JSX.Element => {
    const { values, setFieldValue } = useFormikContext<PaymentScheduleViewModel>();
    const newInstalment = {
        payerName: '',
        label: '',
        dueDate: defaultDueDate,
        type: name.replace('Instalments', ''),
        price: {
            currency: values.currency || 'EUR',
            amount: '',
        },
    };
    return (
        <FieldArray name={name}>
            {({ push, remove }) => {
                return (
                    <>
                        <div className={s.totalPriceAndAddButton}>
                            <h3>
                                <FormattedMessage id={`contract.payment_schedule.${name}.title`} />
                            </h3>
                            <div>
                                <p data-testid={`${name}-total-amount`}>
                                    <FormattedNumber
                                        value={calculateTotalAmountOfInstalment(values[name])}
                                        style="currency"
                                        currency={values.currency || 'EUR'}
                                    />
                                </p>
                                <Button
                                    priority="secondary"
                                    type="button"
                                    onClick={() => push(newInstalment)}
                                    className={s.addInstalmentButton}
                                >
                                    <Add color="var(--ink)" />
                                    <FormattedMessage
                                        id={`contract.payment_schedule.${name}.add`}
                                    />
                                </Button>
                            </div>
                        </div>
                        <div className={s.instalmentContainer}>
                            <div className={s.instalmentsHeaders}>
                                <p className="ink-light">
                                    <FormattedMessage id="contract.payment_schedule.instalment.payer_name" />
                                </p>
                                <p className="ink-light">
                                    <FormattedMessage id="contract.payment_schedule.instalment.label" />
                                </p>
                                <p className="ink-light">
                                    <FormattedMessage id="contract.payment_schedule.instalment.due_date" />
                                </p>
                                <p className="ink-light">
                                    <FormattedMessage id="contract.payment_schedule.instalment.price" />
                                </p>
                            </div>
                            <div>
                                {instalments &&
                                    instalments.length > 0 &&
                                    instalments.map((instalment, index) => (
                                        <Instalment
                                            key={`${name}.${index}`}
                                            index={`${name}.${index}`}
                                            changeDueDate={(date) => {
                                                void setFieldValue(
                                                    `${name}.${index}.dueDate`,
                                                    date,
                                                );
                                            }}
                                            deleteInstalment={() => remove(index)}
                                            duplicateInstalment={() => {
                                                push({
                                                    payerName: '',
                                                    label: '',
                                                    dueDate: defaultDueDate,
                                                    type: name.replace('Instalments', ''),
                                                    price: {
                                                        currency: values.currency,
                                                        amount: instalment.price.amount,
                                                    },
                                                });
                                            }}
                                            instalment={instalment}
                                            currency={values.currency}
                                        />
                                    ))}
                            </div>
                        </div>
                    </>
                );
            }}
        </FieldArray>
    );
};
